module.exports = __webpack_public_path__ + "img/perfect-cosmopolitan-460x295.0ad17f54.jpg";